import * as React from "react";
import type { SVGProps } from "react";
const SvgTrendUp01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m2.4 16.8 5.376-5.17 4.608 4.432L21.6 7.2m0 0h-6.912m6.912 0v6.646"
    />
  </svg>
);
export default SvgTrendUp01;
